import { ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';

import { LoaderService } from 'src/app/services/loader/loader.service';

@Component({
    selector: 'rg-loader',
    templateUrl: 'loader.component.html',
    styleUrls: ['loader.component.scss']
})
export class RgLoaderComponent implements OnDestroy {
  @ViewChild('mask', { static: true }) mask: ElementRef;

  @Input() target: any;
  @Input() name: string;
  @Input() set loading(val: boolean|number) {
    if (typeof val === 'boolean') {
      this.showSpinner = +val;
    } else if (typeof val === 'number') {
      this.showSpinner = val;
    } else {
      this.showSpinner = 0;
    }
  }

  showSpinner = 0;
  statusSubscription: Subscription;

  private bodyStyle = document.body.style;

  constructor(public el: ElementRef, protected cd: ChangeDetectorRef, private loaderService: LoaderService) {
    this.statusSubscription = this.loaderService.status$.subscribe(status => {
      let step = 0;
      if (typeof status === 'number' && !this.name) {
        step = status;
      } else if (typeof status === 'object' && status.name === this.name) {
        step = status.step;
      }
      this.showSpinner = this.showSpinner + step;
      if (this.showSpinner < 0) {
        this.showSpinner = 0;
      }
      this.checkStatus();
    });
  }


  ngOnDestroy(): void {
    this.statusSubscription.unsubscribe();
  }

  checkStatus(): void {
    if (this.showSpinner > 0) {
      this.mask.nativeElement.style.display = 'block';

      if (this.target) {
        this.getBlockable().appendChild(this.mask.nativeElement);
        this.target.style.position = 'relative';
      } else {
        document.body.appendChild(this.mask.nativeElement);
        this.bodyStyle.overflow = 'hidden';
      }
    } else {
      this.el.nativeElement.appendChild(this.mask.nativeElement);
      if (!this.target) {
        this.bodyStyle.removeProperty('overflow');
      }
      this.mask.nativeElement.style.display = 'none';
    }
    this.cd.markForCheck();
  }

  private getBlockable(): HTMLElement {
    return this.target.getBlockableElement ? this.target.getBlockableElement() : this.target;
  }
}
